import sdk from "./liuliangguoSDK"


export default {
    llgBack: function() {
        var params = {
            app_key: 'LLG10005472',
            app_secret: '237e818c89b9494301353129990706a5',
            ad_position_id: '100539',
            phone: '',
            fail_message: '',
            product_name: ''
        };

        //获取广告并展示
        sdk && sdk.getAdAndShow(params, function(res) {
            console.log("流量果" + res);
            if (!res.is_success) {
                console.log(res.message)
            }
        })
    },
    llg: function(tel, msg) {
        var params = {
            app_key: 'LLG10005472',
            app_secret: '237e818c89b9494301353129990706a5',
            ad_position_id: '100537',
            phone: tel,
            fail_message: msg,
            product_name: ''
        };

        //获取广告并展示
        sdk && sdk.getAdAndShow(params, function(res) {
            console.log("流量果" + res);
            if (!res.is_success) {
                console.log(res.message)
            }
        })
    },
    llgSuccess: function(tel) {
        var params = {
            app_key: 'LLG10005472',
            app_secret: '237e818c89b9494301353129990706a5',
            ad_position_id: '100538',
            phone: tel,
            fail_message: '',
            product_name: ''
        };

        //获取广告并展示
        sdk && sdk.getAdAndShow(params, function(res) {
            console.log("流量果" + res);
            if (!res.is_success) {
                console.log(res.message)
            }
        })
    }

}


// WEBPACK FOOTER //
// ./src/common/js/liuliangguo.js